// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__VnhU9","block":"Footer_block__Duhiu","info":"Footer_info__RluGr"};